function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Icon } from '@unite-us/ui';
var Search = /*#__PURE__*/function (_Component) {
  function Search(props) {
    var _this;
    _classCallCheck(this, Search);
    _this = _callSuper(this, Search, [props]);
    _this.onChange = _this.onChange.bind(_this);
    _this.resetValue = _this.resetValue.bind(_this);
    _this.state = {
      value: ''
    };
    return _this;
  }
  _inherits(Search, _Component);
  return _createClass(Search, [{
    key: "onChange",
    value: function onChange(event) {
      this.setState({
        value: event.target.value
      });
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(event.target.value);
      }
    }
  }, {
    key: "resetValue",
    value: function resetValue() {
      this.setState({
        value: ''
      });
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange('');
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "relative leading-none"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: this.props.id,
        className: "absolute w-px h-px p-0 m-[-1px] overflow-hidden border-0"
      }, this.props.label), /*#__PURE__*/React.createElement("input", {
        id: this.props.id,
        className: "bg-light-border-grey border-solid border-b border-t border-light-border-blue block m-0 p-2.5 relative w-full placeholder-placeholder-blue text-sm font-arial-font focus:outline-none",
        type: "text",
        onChange: this.onChange,
        value: this.state.value,
        placeholder: this.props.placeholder
      }), /*#__PURE__*/React.createElement("div", {
        className: "absolute right-2.5 top-4 transform -translate-y-1/2 outline-none"
      }, _.isEmpty(this.state.value) ? /*#__PURE__*/React.createElement(Icon, {
        icon: "IconSearch",
        size: 16,
        color: '#67859E'
      }) : /*#__PURE__*/React.createElement(Icon, {
        icon: "IconCross",
        size: 12,
        color: '#67859E',
        onClick: this.resetValue
      })));
    }
  }]);
}(Component);
Search.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired
};
export default Search;